import _ from 'lodash'

export const mottoOptInMobileMixin = {
  data() {
    return {
      acceptedMobileOptInData: [],
      shouldPromptOptInMobileModal: true,
    }
  },
  computed: {
    hasAcceptedMobileOptInData() {
      return !!this.acceptedMobileOptInData[0]
    },
  },
  watch: {
    acceptedMobileOptInData(newValue, oldValue) {
      if (_.isEqual(newValue, oldValue)) {
        this.shouldPromptOptInMobileModal = true
        return
      }

      if (this.hasAcceptedMobileOptInData && this.shouldPromptOptInMobileModal) {
        this.openOptInMobilePromptModal()
      }

      this.shouldPromptOptInMobileModal = true
    },
  },
  methods: {
    openOptInMobilePromptModal() {
      this.$bvModal.show('modal-opt-in-mobile-prompt')
    },
    openHomeOptInMobilePromptModal() {
      this.$bvModal.show('modalHomeOptInMobilePrompt')
    },
    okOptInMobilePromptModal(hasAccepted) {
      this.acceptedMobileOptInData = hasAccepted ? ['1'] : []
    },
    cancelOptInMobilePromptModal() {
      this.acceptedMobileOptInData = []
    },
    setAcceptedMobileOptInData(bool, promptModal = false) {
      this.shouldPromptOptInMobileModal = promptModal
      if (bool) {
        this.acceptedMobileOptInData = ['1']
        return
      }
      this.acceptedMobileOptInData = []
    },
  },
}
